import FileNotFound from "./FileNotFound";

export default FileNotFound;

export { FileNotFound };
